import Uploader from '../../utils/uploader'
import Config from '../../config'


/**
 * This class represents an image that is stored in amazon storage
 *
 * The class has the same interface as other image classes such as OpeImageLocal so
 * that images from different sources can be treated the same way by the rest of the app
 * @param mix id Some identification for the image
 * @param {string} amazonImageId is the id that the image has at amazon
 * @param {int} width the original width of the image
 * @param {int} height the original height of the image
 */
function OpeImageAmazon (id, amazonImageId, width, height) {
	this.cache = {};
	this.cache.resizedImages = {};
	if (id === null || id === undefined) {
		throw new OpeException("Cannot create new instance of OpeImageAmazon because id parameter is null");
	}
	if (amazonImageId === null || amazonImageId === undefined) {
		throw new OpeException("Cannot create new instance of OpeImageAmazon because amazonImageId parameter is null");
	}
	this.id = id;
	this.width = width;
	this.height = height;
	this.amazonImageId = amazonImageId;
	this.visible = false;
}

/**
 * Get id of image
 * @return {string}
 */
OpeImageAmazon.prototype.getId = function () {
	return this.id;

}

/**
 * Set visible. Mostly used for local images which have to deal a lot with memory handling
 * @param {boolean}
 */
OpeImageAmazon.prototype.setVisible = function (visible) {
	this.visible = visible;
}

/**
 * Is this image currently visible on the users screen?
 * @return {Boolean}
 */
OpeImageAmazon.prototype.isVisible = function () {
	return this.visible;
}

/**
 * Get sourceId
 * Source id is the id which the image has in it's source (amazon, dropbox, facebook...)
 * @return {string}
 */
OpeImageAmazon.prototype.getSourceId = function () {
	return this.amazonImageId;
}

/**
 * ASYNC function
 * Typically used when you want to create an html
 * img tag and you want some url or some base64 data
 * to put into the src attribute of the img tag
 * @param {int} maxSize the max width or height of the image in pixles (you might get less than max)
 * @return promise which then returns an url
 */
OpeImageAmazon.prototype.getSrc = function (maxSize) {
	var self = this;
	if (this.cache.resizedImages.hasOwnProperty(maxSize)) {
		return new Promise(function (resolve, reject) {
			resolve(self.cache.resizedImages[maxSize]);
		});
	}
	return new Promise(function (resolve, reject) {
		Uploader.getThumbnail(self.getSourceId(), maxSize).then(function (data) {
			self.cache.resizedImages[maxSize] = data.url;
			resolve(data.url);
		})['catch'](function (error) {
			displayError(_("Unable to get image. If the problem persists, please contact customer service and give them the details below", {regId: regId, error: error}));
			reject(_("Unable to get image. If the problem persists, please contact customer service and give them the details below", {regId: regId, error: error}));
		});
	});
}


/**
 * ASYNC function
 * This method will give you something to put into the src attribute of an
 * img tag, just like the getSrc method, but with applied filters (rotation, crop, sephia...)
 * If you provide a maxSize param in pixels, it will also resize the image for you.
 * The filter is a json object of the filters to be applied fex:
 * {operation.rotate.angle: 90, operation.rotate.flip: 'FLIP_HORIZONTAL'}
 * @param  {int} maxSize
 * @param {object} filter
 * @return {Promise} which then gives you an url
 */
OpeImageAmazon.prototype.getSrcWithFilter = function (maxSize, filter) {
	var self = this;
	return new Promise(function (resolve, reject) {
		self.getSrc(maxSize).then(function (src) {

			//Check if filters are given
			var hasFilters = false;
			for (var name in filter) {
				if (filter.hasOwnProperty(name)) {
					hasFilters = true;
				}
			}

			var url = Config.EditServerUrl + '/api/EditPost/editByUrl?url=' + encodeURIComponent(src);

			if (hasFilters) {

				var postData = JSON.stringify(filter);

				var xhr = new XMLHttpRequest();
				xhr.open( "POST", url, true );
				xhr.setRequestHeader('Accept', 'image/*');
				xhr.setRequestHeader('Content-type', 'application/json');
				//xhr.setRequestHeader('Content-length', postData.length);
				//xhr.setRequestHeader("Connection", "close");

				// Ask for the result as an ArrayBuffer.
				xhr.responseType = "arraybuffer";

				xhr.onload = function( e ) {
				    // Obtain a blob: URL for the image data.
				    var arrayBufferView = new Uint8Array( this.response );
				    var blob = new Blob( [ arrayBufferView ], { type: "image/jpeg" } );
				    var urlCreator = window.URL || window.webkitURL;
				    var imageUrl = urlCreator.createObjectURL( blob );
				    resolve(imageUrl);
				};

				xhr.onerror = function ( error ) {
					reject({message: "Unable to load image with filter data. Please try again later. If the problem persists, please contact customer service and give them the details about the error.", details: "Cannot get image with filter. Url: " + url, error: error});
				}

				xhr.send(postData);

			} else {
				resolve(src);
			}
		});
	});
}

/**
 * returns Object with data such as originalImageHeight, originalImageWidth
 */
OpeImageAmazon.prototype.getImageData = function () {
	return {originalImageWidth: this.width, originalImageHeight: this.height, sourceId: this.getSourceId(), dateTaken: null};
}

/**
 * Get the width of the original image in pixels
 * @return {int}
 */
OpeImageAmazon.prototype.getWidth = function () {
	return this.width;
}

/**
 * Get the height of the original image in pixels
 * @return {int}
 */
OpeImageAmazon.prototype.getHeight = function () {
	return this.height;
}



export default OpeImageAmazon;
